import {
  ExpectedVolumeFetcherQuery,
  ExpectedVolumeFetcherQueryVariables,
} from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";
import { collectExpectedVolumeRows } from "../lib/ExpectedVolumeDataCollector";

export const expectedVolumeFetcherQuery = gql`
  fragment relatedCustomers on Customer {
    id
    custIndex
    custNo
    name
    isParent
  }
  fragment expectedVolume on ExpectedVolumeResult {
    volumes {
      id
      customer {
        id
      }
      expectedVolume
      routePair {
        id
      }
      sailingCategoryCode
      unitCategoryCode
      volume12Months
      year
      volumeAgreed
    }
  }
  query ExpectedVolumeFetcher($customerId: ID!, $negotiationYear: Int!) {
    productPrice {
      routePair {
        allWithStatusOwn {
          id
          code
        }
      }
      customers {
        byId(id: $customerId) {
          id
          relatedCustomers {
            ...relatedCustomers
          }
          expectedVolumeByFilter(negotiationYear: $negotiationYear) {
            ...expectedVolume
          }

          name
          breadCrumbName
          custIndex
          custNo
          isParent
          custStatus {
            id
            name
          }
          parent {
            id
            preselectedHeadAgreement {
              id
            }
          }
          childCustomers {
            id
          }
          statisticalGrouping {
            id
          }
          invoiceCurrency {
            id
            code
          }
          seller {
            id
            name
          }
          salesRegion {
            id
            code
            name
          }
          isStandardCustomer
          hasRebateAgreements
          writeHistory {
            createdAt {
              isoString
            }
            createdBy {
              id
              name
            }
            modifiedAt {
              isoString
            }
            modifiedBy {
              id
              name
            }
          }
        }
      }
    }
  }
`;

const dataAsExpectedByRoute = (data?: ExpectedVolumeFetcherQuery) => {
  const customer = data?.productPrice.customers.byId;
  const routePairs = data?.productPrice.routePair.allWithStatusOwn;

  if (customer && routePairs) {
    const { expectedVolumeByFilter, relatedCustomers } = customer;

    const expectedVolumeByRoute = collectExpectedVolumeRows(
      routePairs,
      expectedVolumeByFilter,
      relatedCustomers
    );

    return expectedVolumeByRoute;
  }

  return undefined;
};

export const useExpectedVolume = (
  customerId: string,
  negotiationYear: number
) => {
  const { data, loading, error } = useQuery<
    ExpectedVolumeFetcherQuery,
    ExpectedVolumeFetcherQueryVariables
  >(expectedVolumeFetcherQuery, {
    variables: {
      customerId,
      negotiationYear,
    },
  });

  const customer = data?.productPrice.customers.byId;
  const routePairsWithStatusOwn = data?.productPrice.routePair.allWithStatusOwn;

  return {
    expectedVolumeByRoute: dataAsExpectedByRoute(data),
    customer,
    routePairsWithStatusOwn,
    error,
    loading,
  };
};
